import {
  CENTER_OF_EXCELLENCE,
  NeurodiversityContactCareNavigatorEntryPoint,
  NeurodiversitySearcherType,
  TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC,
} from './types'
import { TREATMENT_OPTIONS, TREATMENT_OPTIONS_TYPE } from '../common/constants/treatmentOptions'
import { TOOLKIT_TYPE } from '../wellnessToolkit/types'

export const isToolkitTypeCenterOfExcellence = (
  toolkit?: TOOLKIT_TYPE | string,
  toolkitSubTopic?: TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC | string,
): boolean => {
  return (
    Boolean(toolkit) &&
    Boolean(toolkitSubTopic) &&
    Object.values(CENTER_OF_EXCELLENCE).includes(toolkit as CENTER_OF_EXCELLENCE) &&
    Object.values(TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC).includes(
      toolkitSubTopic as TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC,
    )
  )
}

export const isToolkitTypeNeurodiversity = (toolkit?: TOOLKIT_TYPE) => {
  return toolkit && toolkit === CENTER_OF_EXCELLENCE.NEURODIVERSITY
}

export const isToolkitTypeHealthChallenges = (toolkit?: TOOLKIT_TYPE) => {
  return toolkit && toolkit === CENTER_OF_EXCELLENCE.HEALTH_CHALLENGES
}

export const isToolkitTypeWomensHealth = (toolkit?: TOOLKIT_TYPE) => {
  return toolkit && toolkit === CENTER_OF_EXCELLENCE.WOMENS_HEALTH
}

/**
 * Determine what kind of searcherType neurodiversity page should show
 * @param isUserTeen
 * @param shouldHideChildSearchCTA
 */
export const getDefaultNeurodiversitySearcherType = (isUserTeen: boolean, shouldHideChildSearchCTA: boolean) => {
  if (isUserTeen) {
    return NeurodiversitySearcherType.TEEN
  }
  return shouldHideChildSearchCTA ? NeurodiversitySearcherType.ADULT : NeurodiversitySearcherType.CHILD
}

export const getNeurodiversitySearcherContextFromTreatmentOption = (
  treatmentOption: TREATMENT_OPTIONS_TYPE,
  isUserTeen: boolean,
): {
  searcherType: NeurodiversitySearcherType
  subTopic: TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC | undefined
  contactCareNavEntryPoint: NeurodiversityContactCareNavigatorEntryPoint
} => {
  const isChildTreatmentOption =
    treatmentOption === TREATMENT_OPTIONS.NEUROPSYCHOLOGICAL_EVALUATIONS_CHILD ||
    treatmentOption === TREATMENT_OPTIONS.CAREGIVER_TRAINING_FOR_NEURO ||
    treatmentOption === TREATMENT_OPTIONS.SUPPORT_FOR_NEURODIVERSITY_CHILD
  const searcherType = isChildTreatmentOption
    ? NeurodiversitySearcherType.CHILD
    : isUserTeen
    ? NeurodiversitySearcherType.TEEN
    : NeurodiversitySearcherType.ADULT
  const subTopicByTreatmentOption: Partial<Record<TREATMENT_OPTIONS_TYPE, TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC>> = {
    [TREATMENT_OPTIONS.NEUROPSYCHOLOGICAL_EVALUATIONS]:
      TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC.NEURODIVERSITY_NEUROPSYCHOLOGICAL_EVALUATION,
    [TREATMENT_OPTIONS.NEUROPSYCHOLOGICAL_EVALUATIONS_CHILD]:
      TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC.NEURODIVERSITY_NEUROPSYCHOLOGICAL_EVALUATION_CHILD,
    [TREATMENT_OPTIONS.CAREGIVER_TRAINING_FOR_NEURO]:
      TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC.NEURODIVERSITY_CAREGIVER_TRAINING_FOR_NEURODIVERSE_CHILD,
  }
  const subTopic = subTopicByTreatmentOption[treatmentOption]
  const contactCareNavEntryPoint =
    subTopic != null
      ? NeurodiversityContactCareNavigatorEntryPoint.SELECTED_CARE_OPTION
      : NeurodiversityContactCareNavigatorEntryPoint.NEURODIVERSITY_NAVIGATION
  return { searcherType, subTopic, contactCareNavEntryPoint }
}

export const getToolkitSubTopicLabel = (toolkitSubTopic: TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC) => {
  switch (toolkitSubTopic) {
    case TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC.NEURODIVERSITY_NEUROPSYCHOLOGICAL_EVALUATION:
    case TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC.NEURODIVERSITY_NEUROPSYCHOLOGICAL_EVALUATION_CHILD:
      return 'Neuropsychological evaluations'
    case TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC.NEURODIVERSITY_CAREGIVER_TRAINING_FOR_NEURODIVERSE_CHILD:
      return 'Caregiver Training'
    case TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC.NEURODIVERSITY_TREATMENT_FOR_AUTISM:
    case TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC.NEURODIVERSITY_TREATMENT_FOR_AUTISM_CHILD:
      return 'Support for ASD'
    case TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC.NEURODIVERSITY_TREATMENT_FOR_ADHD:
    case TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC.NEURODIVERSITY_TREATMENT_FOR_ADHD_CHILD:
      return 'Support for ADHD'
    case TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC.NEURODIVERSITY_OTHER_NEURODIVERSITY_TOPICS:
    case TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC.NEURODIVERSITY_OTHER_NEURODIVERSITY_TOPICS_CHILD:
      return 'Support for other neurodiversity needs'
    default:
      return toolkitSubTopic
  }
}
